import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import CentrosServiciosData from '../../Components/Admin/CentrosServiciosData/CentrosServiciosData';

export default function CentrosServicios() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <CentrosServiciosData />
                </div>
            </section>
        </div>
    );
}
